import { motion } from 'framer-motion';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import EditPencilIcon from '../../../images/icons/EditPencil';
import TrashIcon from '../../../images/icons/Trash';
import WarningSolidIcon from '../../../images/icons/WarningSolid';
import { Colors } from '../../../themes/colors';
import '../../../themes/global.scss';
import '../../../themes/home.scss';
import isHoliday from '../isHoliday';

export default ({ job, deleteJobPressed, editHasBeenClicked }) => {
  const {
    localStart, localEnd, rate, is_break_paid, break_time, localDate, profession, specialty
    ,
  } = job;
  const allProfessions = useSelector((state) => state.user.allProfessions);
  const selectedProfession = allProfessions.filter(
    (el) => el.code === profession,
  )[0];

  const formattedDate = moment.utc(localDate).set({ hour: 8, minute: 0, second: 0 });

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.5,
        exit: { duration: 0.2 },
        layout: { duration: 0.3 },
      }}
      layout
      key={localDate}
      className="card"
      data-cy="mdb-job-card"
      style={{
        backgroundColor: Colors.white,
        width: '368px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 15,
        border: `1px solid ${Colors.neutral_100}`,
        boxShadow: '0px 3px 3px rgba(0,0,0,0.4)',
        boxShadow: '0px 3px 10px 1px #00000026'
      }}
    >
      <div className="card-body" style={{ width: '100%' }}>
        <div
          style={{
            borderBottom: `1px solid ${Colors.neutral_100}`,
            marginBottom: 10,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: "18px 16px"
          }}
        >
          <span className="card-title" style={styles.titleStyle}>
            {moment.utc(localDate).format('ddd, MMM DD, YYYY')}
          </span>
          
          <div style={{marginRight: 10, marginBottom: 8, display: "flex", gap: 16}}>
            <button style={{"all": "unset", cursor: "pointer"}} data-cy="edit-shift" onClick={() => editHasBeenClicked(localDate)}>
              <EditPencilIcon color={Colors.secondary_500} />
            </button>
            <button style={{"all": "unset", cursor: "pointer"}} data-cy="remove-shift" onClick={() => deleteJobPressed(localDate)}>
              <TrashIcon color={Colors.secondary_500} />
            </button>
            {isHoliday(formattedDate) && (<WarningSolidIcon color={Colors.warning_500} />)}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', margin: "0 26px 26px 26px", gap: 2 }}>
          <span style={styles.textStyle}>
            {selectedProfession.name}
          </span>
          <span style={styles.textStyle}>
            {specialty?.split('_')?.[1] || 'General'}
          </span>
          <span style={{...styles.textStyle, textTransform: "lowercase"}}>{`${localStart} - ${localEnd}`}</span>
          <span style={styles.textStyle}>
            {`Break ${is_break_paid ? '(Paid)' : '(Unpaid)'}: ${break_time} Min `}
          </span>
          <span style={styles.textStyle}>{`$${rate?.toFixed(2) || ''}/hr`}</span>
        </div>
      </div>
    </motion.div>
  );
};

const styles = {
  titleStyle: {
    color: Colors.neutral_600,
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    fontSize: 18,
    marginBottom: 8,
    marginLeft: 10,
    textTransform: 'capitalize',
  },
  textStyle: {
    color: Colors.neutral_600,
    fontFamily: 'Nunito',
    fontSize: 16,
    marginTop: 2,
  },
};
